module.exports = __webpack_public_path__ + "img/huangtao.076d19b8.jpg";